// extracted by mini-css-extract-plugin
export default {"container":"CarouselDropzone-module__container--NF4tS","label":"CarouselDropzone-module__label--Pvnpt"};